import { FunctionComponent, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { FormLabel } from 'react-bootstrap';

import { Container } from '../../components/Container';
import { Label, TextInput, TextFeedback } from '../../components/Input';
import { Button } from '../../components/Button';
import { Form } from '../../components/Form';
import { Link } from '../../components/Link';
import { Text } from '../../components/Typography';

import { getUser } from '../../selectors/user';
import { signInRequest } from '../../actions/user';

import banner from '../../assets/02-BANNER-SITO-2109x647.png';

import classes from './sign-in.module.scss';

export const SignIn: FunctionComponent = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const user = useSelector(getUser);
  const dispatch = useDispatch();

  const signIn = useCallback(
    (values: { [key: string]: string }) => {
      dispatch(
        signInRequest({ email: values.email, password: values.password })
      );
    },
    [dispatch]
  );

  return (
    <div className={classes.signIn}>
      {/* <Image src={banner} fluid /> */}

      <Container>
        <div className={classes.intro}>
          <Text className={classes.text}>
            Se fai parte della community,{' '}
            <strong>ricevi sconti personalizzati</strong>, la newsletter con le{' '}
            <strong>anteprime su prodotti e concorsi esclusivi</strong>. E in
            più, solo dall’area riservata{' '}
            <strong>
              controlli lo stato dei tuoi ordini e registri la garanzia
            </strong>{' '}
            dei prodotti acquistati.
          </Text>

          <div>
            <Text className={classes.title}>
              <strong>Registrati ora per diventare member Lagostina!</strong>
            </Text>
            <Link to={'/sign-up'}>
              <Button
                disabled={user.fetching}
                loading={user.fetching}
                type={'submit'}
              >
                Registrati
              </Button>
            </Link>
          </div>

          <Text className={classes.title}>
            <strong>Hai già un account? Accedi all’area riservata</strong>
          </Text>
        </div>

        <Form onSubmit={handleSubmit(signIn)} centered>
          <div>
            <Label>Username</Label>
            <TextInput
              type={'text'}
              {...register('email', {
                required: 'Questo campo è obbligatorio',
              })}
            />
            {errors.email && (
              <TextFeedback>{errors.email.message}</TextFeedback>
            )}
          </div>

          <div>
            <Label>Password</Label>
            <TextInput
              type={'password'}
              {...register('password', {
                required: 'Questo campo è obbligatorio',
              })}
            />
            {errors.password && (
              <TextFeedback>{errors.password.message}</TextFeedback>
            )}
          </div>

          <FormLabel>
            <strong>Cliccando su login</strong> dichiaro di avere almeno 16 anni
            e che accetto i{' '}
            <a
              href={'https://lagostina.it/it/condizioni-di-uso'}
              target={'_blank'}
              rel={'noreferrer noopener'}
            >
              Termini e Condizioni
            </a>{' '}
            e la{' '}
            <a
              href={'https://lagostina.it/privacy-policy.pdf'}
              target={'_blank'}
              rel={'noreferrer noopener'}
            >
              data privacy policy
            </a>
          </FormLabel>

          <Button
            disabled={user.fetching}
            loading={user.fetching}
            type={'submit'}
          >
            Login
          </Button>

          <Link to={'/reset-password'}>
            Hai dimenticato la password? Clicca qui
          </Link>

          <Link to={'/sign-up'}>Non sei ancora registrato? Clicca qui</Link>

          <Link to={'/reset-password'}>
            Sei iscritto alla newsletter ma non hai un account? Clicca qui
          </Link>
        </Form>
      </Container>
    </div>
  );
};
